module.exports = __webpack_public_path__ + "img/number-thumb-29.ab6fb44c.jpg";